import { Navigate } from 'react-router-dom';
import { APP_PATHS } from '../routes/paths';
import { useUser } from '../hooks/useUser';
import { STORAGE_KEYS } from '../constants/storage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  const { user } = useUser();

  if (!token || !user) {
    return <Navigate to={APP_PATHS.login} replace />;
  }

  if (!user.isEmailVerified) {
    return <Navigate to={APP_PATHS.verifyEmail} replace />;
  }

  return <>{children}</>;
}
